'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var reduxActions = require('redux-actions');
var R = require('ramda');
var reselect = require('reselect');
var redux = require('redux');
var websockets = require('@rushplay/websockets');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var reactRedux = require('react-redux');
var api = require('@rushplay/api-client');
var recompose = require('recompose');
var reactHelmetAsync = require('react-helmet-async');
var connectedReactRouter = require('connected-react-router');
var session = require('@rushplay/session');
var url = _interopDefault(require('url'));

var STORE_GAMES = 'casino/games/STORE_GAMES';
var STORE_GAME_PROPS = 'casino/games/STORE_GAME_PROPS';
var CLEAR_GAME_OPTIONS = 'casino/games/CLEAR_GAME_OPTIONS';
var CLEAR_QUERY_RESULTS = 'casino/games/CLEAR_QUERY_RESULTS';
var APPEND_QUERY_RESULTS = 'casino/games/APPEND_QUERY_RESULTS';
var REPLACE_QUERY_RESULTS = 'casino/games/REPLACE_QUERY_RESULTS';
var STORE_QUERY_OFFSET = 'casino/games/STORE_QUERY_OFFSET';
var UPDATE_FILTER_GAME_TYPE = 'casino/games/UPDATE_FILTER_GAME_TYPE';

var storeGames = reduxActions.createAction(STORE_GAMES);
var storeGameProps = reduxActions.createAction(STORE_GAME_PROPS, function (id, props) {
  return {
    id: id,
    props: props
  };
});
var clearGameOptions = reduxActions.createAction(CLEAR_GAME_OPTIONS, function (id) {
  return {
    id: id
  };
});
var clearQueryResults = reduxActions.createAction(CLEAR_QUERY_RESULTS);
var appendQueryResults = reduxActions.createAction(APPEND_QUERY_RESULTS);
var replaceQueryResults = reduxActions.createAction(REPLACE_QUERY_RESULTS);
var storeQueryOffset = reduxActions.createAction(STORE_QUERY_OFFSET);
var updateFilterGameType = reduxActions.createAction(UPDATE_FILTER_GAME_TYPE);

var actions = /*#__PURE__*/Object.freeze({
  storeGames: storeGames,
  storeGameProps: storeGameProps,
  clearGameOptions: clearGameOptions,
  clearQueryResults: clearQueryResults,
  appendQueryResults: appendQueryResults,
  replaceQueryResults: replaceQueryResults,
  storeQueryOffset: storeQueryOffset,
  updateFilterGameType: updateFilterGameType
});

var getAllGames = R.prop('games');

var getQueryResults = function getQueryResults(state, props) {
  return R.pathOr([], ['queryResults', R.prop('queryName', props), '__items'], state);
};
/**
 * Gets the current number of fetched games for a given query.
 *
 * @param {Object} state
 * @param {Object} params
 * @param {string} params.queryName the name of the query
 *
 * @returns {number} the number of games in store
 *
 * @example
 * getCurrentCount(state, { queryName: 'popular' })
 */


var getCurrentCount = reselect.createSelector([getQueryResults], R.length);
/**
 * Gets the total number of games available on the remote for a given query.
 *
 * @param {Object} state
 * @param {Object} params
 * @param {string} params.queryName the name of the query
 *
 * @returns {number} the number of games available on remote for a given query
 *
 * @example
 * getTotalCount(state, { queryName: 'popular' })
 */

var getTotalCount = function getTotalCount(state, props) {
  return R.pathOr(Infinity, ['queryResults', R.prop('queryName', props), 'totalCount'], state);
};
/**
 * Gets the total number of games available on the remote for a given query.
 *
 * @param {Object} state
 * @param {Object} params
 * @param {string} params.queryName the name of the query
 *
 * @returns {number} the offset number (currentCount stored just before searchGames request is made)
 *
 * @example
 * getOffset(state, { queryName: 'popular' })
 */

var getOffset = function getOffset(state, props) {
  return R.pathOr(0, ['queryResults', R.prop('queryName', props), 'offset'], state);
};
var getDesiredCount = reselect.createSelector([getTotalCount, getOffset, function (_, props) {
  return props.limit;
}], function (total, offset, limit) {
  var desired = offset + limit;
  return Math.min(total, desired);
});
/**
 * Gets game with specified id.
 *
 * @param {Object} state
 * @param {Object} params
 * @param {number} params.id the id of the game
 *
 * @returns {Object} a game
 *
 * @example
 * getGame(state, { id: 123 })
 */

var getGame = reselect.createSelector([function (_, props) {
  return props.id;
}, getAllGames], R.prop);
/**
 * Gets games for a given query.
 *
 * @param {Object} state
 * @param {Object} params
 * @param {string} params.queryName the name of the query
 *
 * @returns {Array.<Object>} games for a given query
 *
 * @example
 * getGames(state, { queryName: 'popular' })
 */

var getGames = reselect.createSelector([getQueryResults, getAllGames], function (queryResults, allGames) {
  return R.map(function (id) {
    return R.prop(id, allGames);
  }, queryResults);
});
var getGameIds = reselect.createSelector([getQueryResults, getDesiredCount], function (queryResults, desiredCount) {
  return R.take(desiredCount, R.concat(queryResults, R.repeat(null, desiredCount)));
});
var areGamesLoading = reselect.createSelector([getDesiredCount, getCurrentCount], function (desired, current) {
  return desired > current;
});
/**
 * Returns uniq gameTypes for a given query
 *
 * @param {Object} state
 * @returns {Array.<string>}
 *
 * @example
 * getGameTypes(state, { queryName: 'live' })
 */

var getGameTypes = reselect.createSelector(getGames, function (games) {
  return R.uniq(R.values(R.pluck('gameType', games)));
});
/**
 * Returns selected gameType
 *
 * @param {Object} state
 * @returns {string}
 */

var getGameType = function getGameType(state) {
  return R.path(['filters', 'gameType'], state);
};
/**
 * @typedef {Object} TableGame
 * @prop {boolean} tableOpen
 * @prop {string} gameType
 */

/**
 * @param {TableGame} game live casino game
 * @returns {boolean}
 */

var isOpen = function isOpen(game) {
  return game.tableOpen === true;
};
/**
 * @param {TableGame} game live casino game
 * @returns {function(TableGame): boolean}
 */


var hasSeatsAvailable = function hasSeatsAvailable(game) {
  return game.seatsAvailable !== 0;
};
/**
 * @param {TableGame}
 * @returns {boolean}
 */


var isLiveLobby = function isLiveLobby(game) {
  return R.includes('livefav', game.tags);
};
/**
 * @param {string} gameType
 * @returns {function(TableGame): boolean}
 */


var isOfGameType = function isOfGameType(gameType) {
  return function (game) {
    return gameType === 'all' || game.gameType === gameType;
  };
};
/**
 * Filters live casino games depending on filter criteria
 *
 * @param {Object} state
 * @param {Object} params
 * @param {string} params.queryName the name of the query
 *
 * @returns {Array.<Object>}
 */


var getFilteredGames = reselect.createSelector([getGames, getGameType], function (games, gameType) {
  return R.filter(R.allPass([isOpen, hasSeatsAvailable, isOfGameType(gameType)]), R.values(games));
});
/**
 * Filters live casino games for lobby page
 *
 * @param {Object} state
 * @param {Object} params
 * @param {string} params.queryName the name of the query
 *
 * @returns {Array.<Object>}
 */

var getFilteredLobbyLiveGames = reselect.createSelector([getGames], function (games) {
  return R.filter(R.allPass([isLiveLobby, isOpen]), R.values(games));
});

var selectors = /*#__PURE__*/Object.freeze({
  getCurrentCount: getCurrentCount,
  getTotalCount: getTotalCount,
  getOffset: getOffset,
  getDesiredCount: getDesiredCount,
  getGame: getGame,
  getGames: getGames,
  getGameIds: getGameIds,
  areGamesLoading: areGamesLoading,
  getGameTypes: getGameTypes,
  getGameType: getGameType,
  getFilteredGames: getFilteredGames,
  getFilteredLobbyLiveGames: getFilteredLobbyLiveGames
});

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function gamesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.error) {
    return state;
  }

  switch (action.type) {
    case STORE_GAME_PROPS:
      {
        return R.mergeDeepLeft(_defineProperty({}, action.payload.id, action.payload.props), state);
      }

    case websockets.TABLE_UPDATED:
      {
        return R.mergeDeepLeft(R.indexBy(R.prop('id'), action.payload), state);
      }

    case CLEAR_GAME_OPTIONS:
      {
        var stringify = R.unless(R.is(String), R.toString);
        return R.pipe(R.dissocPath([stringify(action.payload.id), 'options']), R.dissocPath([stringify(action.payload.id), 'blitzProperties']))(state);
      }

    case STORE_GAMES:
      {
        return R.mergeDeepLeft(action.payload, state);
      }

    default:
      return state;
  }
}

function queryResultsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.error) {
    return state;
  }

  switch (action.type) {
    case APPEND_QUERY_RESULTS:
      {
        var _action$payload = action.payload,
            name = _action$payload.name,
            ids = _action$payload.ids,
            totalCount = _action$payload.totalCount;
        return R.assoc(name, {
          offset: state[name].offset,
          totalCount: totalCount,
          __items: R.uniq(R.concat(R.pathOr([], [name, '__items'], state), ids))
        }, state);
      }

    case REPLACE_QUERY_RESULTS:
      {
        var _action$payload2 = action.payload,
            _name = _action$payload2.name,
            _ids = _action$payload2.ids,
            _totalCount = _action$payload2.totalCount;
        return R.assoc(_name, {
          totalCount: _totalCount,
          __items: _ids
        }, state);
      }

    case STORE_QUERY_OFFSET:
      {
        var _action$payload3 = action.payload,
            _name2 = _action$payload3.name,
            offset = _action$payload3.offset;
        return R.assocPath([_name2, 'offset'], offset, state);
      }

    case CLEAR_QUERY_RESULTS:
      {
        return R.dissoc(action.payload, state);
      }

    default:
      return state;
  }
}

var initialFilterState = {
  gameType: 'all'
};

function filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFilterState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.error) {
    return state;
  }

  switch (action.type) {
    case UPDATE_FILTER_GAME_TYPE:
      {
        return R.assoc('gameType', action.payload, state);
      }

    default:
      return state;
  }
}

var reducer = redux.combineReducers({
  games: gamesReducer,
  queryResults: queryResultsReducer,
  filters: filtersReducer
});

var trimParams = R.omit(['limit', 'offset']);

var paramsDidChange = function paramsDidChange(prevParams, newParams) {
  return R.not(R.equals(trimParams(prevParams), trimParams(newParams)));
};

var GameQuery =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GameQuery, _React$Component);

  function GameQuery(props) {
    var _this;

    _classCallCheck(this, GameQuery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GameQuery).call(this, props));
    props.onFetch();
    return _this;
  }

  _createClass(GameQuery, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onClear();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (paramsDidChange(prevProps.params, this.props.params)) {
        this.props.onFetch();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        games: this.props.games,
        ids: this.props.ids,
        isLoading: this.props.isLoading,
        totalCount: this.props.totalCount,
        onLoadMore: this.props.onLoadMore
      });
    }
  }]);

  return GameQuery;
}(React__default.Component);
GameQuery.propTypes = {
  children: PropTypes.PropTypes.func,
  games: PropTypes.PropTypes.array.isRequired,
  mountPoint: PropTypes.PropTypes.string.isRequired,
  name: PropTypes.PropTypes.string.isRequired,
  isLoading: PropTypes.PropTypes.bool,
  ids: PropTypes.PropTypes.array.isRequired,
  params: PropTypes.PropTypes.shape({
    mobile: PropTypes.PropTypes.bool,
    limit: PropTypes.PropTypes.number,
    offset: PropTypes.PropTypes.number,
    order: PropTypes.PropTypes.string,
    tags: PropTypes.PropTypes.arrayOf(PropTypes.PropTypes.string),
    recent: PropTypes.PropTypes.bool,
    jackpot: PropTypes.PropTypes.bool,
    text: PropTypes.PropTypes.string
  }).isRequired,
  totalCount: PropTypes.PropTypes.number,
  onClear: PropTypes.PropTypes.func.isRequired,
  onFetch: PropTypes.PropTypes.func.isRequired,
  onLoadMore: PropTypes.PropTypes.func
};

var indexById = R.indexBy(R.prop('id'));

function getGamesFromResponse(name, response) {
  return R.path(['value', 'result', name], response);
}

function fetchGames(name, params) {
  return [storeQueryOffset({
    name: name,
    offset: params.offset
  }), api.searchGames(_defineProperty({}, name, params), {
    success: function success(response) {
      var games = getGamesFromResponse(name, response);
      var storeQueryResults = params.offset ? appendQueryResults : replaceQueryResults;
      return [storeGames(indexById(games)), storeQueryResults({
        name: name,
        ids: R.pluck('id', games),
        totalCount: R.path([name, 'totalCount'], response.value.meta)
      })];
    },
    failure: function failure() {
      // TODO: errors when fetching should be handled by the fetching mechanism.
      // The thing here, the `failure` callback, is actually more akin to a
      // `catch`, i.e. "There was an error, what do you want to do about it?".
      return storeGames(new Error('errors.http.fetch-failure'));
    },
    version: 2
  })];
}

function loadMore(name, params, currentCount) {
  return fetchGames(name, R.assoc('offset', currentCount, params));
}

function mapStateToProps(state, ownProps) {
  var localState = R.prop(ownProps.mountPoint, state);
  var queryName = {
    queryName: ownProps.name
  };
  var currentCount = getCurrentCount(localState, queryName);
  var totalCount = getTotalCount(localState, queryName);
  return {
    games: getGames(localState, queryName),
    ids: getGameIds(localState, {
      queryName: ownProps.name,
      limit: ownProps.params.limit
    }),
    localState: localState,
    hasMore: totalCount > currentCount,
    currentCount: currentCount,
    isLoading: areGamesLoading(localState, {
      queryName: ownProps.name,
      limit: ownProps.params.limit
    }),
    totalCount: totalCount
  };
}

function makeDispatchToProps() {
  var dependencies = {};
  var memoizedActions = {};
  return function mapDispatchToProps(dispatch, props) {
    function isStale(key, propNames) {
      var initialized = R.has(key, dependencies);
      var dependencyProps = R.pick(propNames, props);
      var changed = R.not(R.equals(dependencies[key], dependencyProps));
      var stale = !initialized || changed;

      if (stale) {
        dependencies[key] = dependencyProps;
      }

      return stale;
    }

    if (isStale('onClear', ['name'])) {
      memoizedActions.onClear = function onClear() {
        dispatch(clearQueryResults(props.name));
      };
    }

    if (isStale('onFetch', ['name', 'params'])) {
      memoizedActions.onFetch = function onFetch() {
        dispatch(fetchGames(props.name, props.params));
      };
    }

    if (isStale('onLoadMore', ['hasMore', 'name', 'params', 'currentCount'])) {
      memoizedActions.onLoadMore = props.hasMore ? function () {
        return dispatch(loadMore(props.name, props.params, props.currentCount));
      } : undefined;
    }

    return {
      onClear: memoizedActions.onClear,
      onFetch: memoizedActions.onFetch,
      onLoadMore: memoizedActions.onLoadMore
    };
  };
}

var connector = R.compose(reactRedux.connect(mapStateToProps, null, null, // We're doing a deep comparison of props (which is heavier, but
// will stop the component from needless rerenders as some of the
// own props are not of primitive data types)
{
  areStatePropsEqual: R.equals
}), reactRedux.connect(null, makeDispatchToProps));

var GameQuery$1 = connector(GameQuery);

var LiveCasinoQuery =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LiveCasinoQuery, _React$Component);

  function LiveCasinoQuery() {
    _classCallCheck(this, LiveCasinoQuery);

    return _possibleConstructorReturn(this, _getPrototypeOf(LiveCasinoQuery).apply(this, arguments));
  }

  _createClass(LiveCasinoQuery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onFetch();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onClear();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        games: this.props.games,
        ids: this.props.ids
      });
    }
  }]);

  return LiveCasinoQuery;
}(React__default.Component);
LiveCasinoQuery.propTypes = {
  children: PropTypes.PropTypes.func,
  ids: PropTypes.PropTypes.arrayOf(PropTypes.PropTypes.number),
  games: PropTypes.PropTypes.arrayOf(PropTypes.PropTypes.object),
  gameType: PropTypes.PropTypes.string.isRequired,
  onClear: PropTypes.PropTypes.func.isRequired,
  onFetch: PropTypes.PropTypes.func.isRequired
};

var QUERY_NAME = 'live';

function fetchGames$1(type, liveCasinoChannel) {
  return api.fetchLiveCasinoTables({
    type: type,
    config: {
      success: function success(response) {
        var ids = R.uniq(R.pluck('id', R.defaultTo([], response.value)));
        return [storeGames(R.indexBy(R.prop('id'), response.value)), replaceQueryResults({
          ids: ids,
          name: QUERY_NAME,
          totalCount: R.length(ids)
        }), websockets.subscribe(liveCasinoChannel)];
      },
      failure: function failure() {
        // TODO: errors when fetching should be handled by the fetching mechanism.
        // The thing here, the `failure` callback, is actually more akin to a
        // `catch`, i.e. "There was an error, what do you want to do about it?".
        return storeGames(new Error('errors.http.fetch-failure'));
      },
      version: 1
    }
  });
}

function mapStateToProps$1(state, ownProps) {
  var localState = R.prop(ownProps.mountPoint, state);
  var queryName = {
    queryName: QUERY_NAME
  };
  var games = ownProps.lobby ? getFilteredLobbyLiveGames(localState, queryName) : getFilteredGames(localState, queryName);
  return {
    games: games,
    gameType: getGameType(localState),
    ids: R.pluck('id', games)
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  var liveCasinoChannel = ownProps.liveCasinoChannel || 'private-live-casino';
  return redux.bindActionCreators({
    onClear: function onClear() {
      return [clearQueryResults(QUERY_NAME), websockets.unsubscribe(liveCasinoChannel)];
    },
    onFetch: function onFetch() {
      return fetchGames$1(ownProps.clientType, liveCasinoChannel);
    }
  }, dispatch);
}

var connector$1 = R.compose(recompose.setPropTypes({
  clientType: PropTypes__default.string,
  lobby: PropTypes__default.bool,
  mountPoint: PropTypes__default.string.isRequired,
  liveCasinoChannel: PropTypes__default.string
}), reactRedux.connect(mapStateToProps$1, mapDispatchToProps));

var LiveCasinoQuery$1 = connector$1(LiveCasinoQuery);

function GameIframeContainer(props) {
  if (!props.src) {
    return null;
  }

  if (props.redirect) {
    window.location = props.src;
    return null;
  } //TODO: scrolling="no" is deprecated, it is recommended to use
  //style="overflow: hidden" instead, but that does not seem to work in games case.
  //The reason for having this attribute is that when the game loads, one
  //can see a blink of scrollbars for a monent, and then they dissapear.


  return React__default.createElement("iframe", {
    height: "100%",
    scrolling: "no",
    src: props.src,
    width: "100%",
    onLoad: props.onLoad,
    ref: props.innerRef
  });
}

GameIframeContainer.propTypes = {
  game: PropTypes__default.object.isRequired,
  innerRef: PropTypes__default.node,
  src: PropTypes__default.string,
  redirect: PropTypes__default.bool,
  onLoad: PropTypes__default.func
};

function mapStateToProps$2(state, props) {
  return {
    src: "".concat(R.path(['blitzProperties', 'launchUrl'], props.game), "&classicModeUrl=").concat(encodeURIComponent(props.classicModeGameUrl)),
    redirect: typeof window.orientation !== 'undefined'
  };
}

var connector$2 = reactRedux.connect(mapStateToProps$2, null);
var BlitzIframeContainer = connector$2(GameIframeContainer);

function mapStateToProps$3(state, props) {
  return {
    src: R.path(['options', 'iframeSrc'], props.game),
    redirect: typeof window.orientation !== 'undefined'
  };
}

var connector$3 = reactRedux.connect(mapStateToProps$3, null);
var GameIframeContainer$1 = connector$3(GameIframeContainer);

var mgFlashGames = 'https://quickfireessl.gamesassists.eu/';

var MicrogamingGameContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MicrogamingGameContainer, _React$Component);

  function MicrogamingGameContainer() {
    var _this;

    _classCallCheck(this, MicrogamingGameContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MicrogamingGameContainer).call(this));
    _this.iframeRef = React__default.createRef();
    _this.handleRealityCheck = _this.handleRealityCheck.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MicrogamingGameContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isRealityCheck !== prevProps.isRealityCheck) {
        return this.handleRealityCheck('StopGamePlay');
      } else {
        return this.handleRealityCheck('ReStartGamePlay');
      }
    }
  }, {
    key: "handleRealityCheck",
    value: function handleRealityCheck(action) {
      // This bit probably doesn't work, but leaving it here just in case it will in Production
      if (this.iframeRef.current) {
        this.iframeRef.current.contentWindow.postMessage(action, mgFlashGames);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        style: {
          height: '100%',
          width: '100%'
        }
      }, React__default.createElement(GameIframeContainer$1, _extends({}, this.props, {
        innerRef: this.iframeRef
      })));
    }
  }]);

  return MicrogamingGameContainer;
}(React__default.Component);

MicrogamingGameContainer.PropTypes = {
  innerRef: PropTypes__default.func
};

var NetEntGameContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NetEntGameContainer, _React$Component);

  function NetEntGameContainer() {
    var _this;

    _classCallCheck(this, NetEntGameContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NetEntGameContainer).call(this));
    _this.netEntExtendRef;
    _this.gameLaunchSuccess = _this.gameLaunchSuccess.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NetEntGameContainer, [{
    key: "gameLaunchSuccess",
    value: function gameLaunchSuccess(netEntExtend) {
      var _this2 = this;

      this.netEntExtendRef = netEntExtend;
      netEntExtend.addEventListener('gameReady', function () {
        netEntExtend.addEventListener('gameRoundStarted', function () {
          return netEntExtend.get('balanceInCurrency', _this2.props.onParseAndUpdateBalance);
        });
        netEntExtend.addEventListener('gameRoundEnded', function () {
          return netEntExtend.get('balanceInCurrency', _this2.props.onParseAndUpdateBalance);
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isRealityCheck !== prevProps.isRealityCheck) {
        this.props.onGameStop(this.netEntExtendRef);
      }
    }
  }, {
    key: "handleGameInclusion",
    value: function handleGameInclusion() {
      this.props.onGameLaunch(this.props.game.options, this.props.authenticated, this.gameLaunchSuccess);
      window.netent_onLeaveTableClicked = this.props.redirectToLobby;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        id: "neGameClient"
      }), R.path(['game', 'options'], this.props) && React__default.createElement(reactHelmetAsync.Helmet, {
        onChangeClientState: function onChangeClientState(state, _ref) {
          var scriptTags = _ref.scriptTags;

          if (scriptTags) {
            var scriptTag = scriptTags.filter(function (item) {
              return item.src.indexOf('gameinclusion') >= 0;
            });

            if (scriptTag.length) {
              scriptTag[0].onload = _this3.handleGameInclusion.bind(_this3);
            }
          }
        }
      }, React__default.createElement("script", {
        src: "".concat(this.props.game.options.staticServer, "/gameinclusion/library/gameinclusion.js")
      })), this.props.children);
    }
  }]);

  return NetEntGameContainer;
}(React__default.Component);

NetEntGameContainer.propTypes = {
  authenticated: PropTypes__default.bool,
  children: PropTypes__default.node,
  game: PropTypes__default.object.isRequired,
  isRealityCheck: PropTypes__default.string.isRequired,
  liveCasinoLobby: PropTypes__default.string.isRequired,
  redirectToLobby: PropTypes__default.func,
  onError: PropTypes__default.func.isRequired,
  onGameLaunch: PropTypes__default.func,
  onGameStop: PropTypes__default.func,
  onParseAndUpdateBalance: PropTypes__default.func
};

function mapDispatchToProps$1(dispatch, props) {
  return {
    onParseAndUpdateBalance: function onParseAndUpdateBalance(balance) {
      var balanceCents = parseInt(balance.match(/\d+/g).join(''), 10);
      dispatch(session.updateBalance({
        balanceCents: balanceCents
      }));
    },
    onGameLaunch: function onGameLaunch(options, authenticated, gameLaunchSuccess) {
      var isMobile = typeof window.orientation !== 'undefined';
      var success = authenticated && !isMobile ? gameLaunchSuccess : null;
      window.netent.launch(options, success, function (error) {
        return props.onError(error);
      });
    },
    onGameStop: function onGameStop(netEntExtendRef) {
      return netEntExtendRef && netEntExtendRef.call('stopAutoplay', []);
    },
    redirectToLobby: function redirectToLobby() {
      dispatch(connectedReactRouter.push(props.liveCasinoLobby));
    }
  };
}

var connector$4 = reactRedux.connect(null, mapDispatchToProps$1);

var NetEntGameContainer$1 = connector$4(NetEntGameContainer);

var PlayNGoGameContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(PlayNGoGameContainer, _Component);

  function PlayNGoGameContainer() {
    _classCallCheck(this, PlayNGoGameContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(PlayNGoGameContainer).apply(this, arguments));
  }

  _createClass(PlayNGoGameContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.scriptSrc) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.error('PlayNGoGameContainer must have scriptSrc prop.');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.redirect) {
        window.location = this.props.scriptSrc;
        return null;
      }

      return React__default.createElement("div", {
        style: {
          height: '100%',
          width: '100%'
        }
      }, React__default.createElement(reactHelmetAsync.Helmet, null, React__default.createElement("script", {
        src: this.props.scriptSrc
      })), React__default.createElement("div", {
        id: "game-container"
      }));
    }
  }]);

  return PlayNGoGameContainer;
}(React.Component);

PlayNGoGameContainer.propTypes = {
  redirect: PropTypes__default.bool,
  scriptSrc: PropTypes__default.string.isRequired
};

function mapStateToProps$4(state, props) {
  return {
    redirect: typeof window.orientation !== 'undefined',
    scriptSrc: props.game.options.scriptSrc
  };
}

var connector$5 = reactRedux.connect(mapStateToProps$4, null);

var PlayNGoGameContainer$1 = connector$5(PlayNGoGameContainer);

var LottolandIframeContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LottolandIframeContainer, _React$Component);

  function LottolandIframeContainer() {
    var _this;

    _classCallCheck(this, LottolandIframeContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LottolandIframeContainer).call(this));
    _this.handleScriptLoad = _this.handleScriptLoad.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LottolandIframeContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.handleScriptLoad();

      window.lottolandEventRouter = function (eventData) {
        switch (eventData.type) {
          case 'betPlaced':
            _this2.props.onEvent('lottoland/bet-placed');

            break;

          case 'userLogin':
            _this2.props.onEvent('lottoland/login');

            break;

          case 'topUp':
            _this2.props.onEvent('lottoland/deposit');

            break;

          case 'fundingSettings':
            _this2.props.onEvent('lottoland/money-limit');

            break;
        }
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window.llsdk) {
        window.llsdk.destroy();
      }

      delete window.lottolandEventRouter;
      window.clearTimeout(this.timeout);
    }
  }, {
    key: "handleScriptLoad",
    value: function handleScriptLoad() {
      if (window.llsdk) {
        window.llsdk.init();
      } else {
        this.timeout = window.setTimeout(this.handleScriptLoad, 200);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", null, React__default.createElement(reactHelmetAsync.Helmet, null, React__default.createElement("script", {
        src: "https://jscdn.lttlapp.com/sdk/sdk.v1.js"
      })), React__default.createElement("lottoland-app", {
        "data-version": "1.0",
        "data-operator-id": this.props.game.options.operatorId,
        "data-host": this.props.game.options.launchUrl,
        "data-path": this.props.game.options.gamePath,
        "data-event-router": "lottolandEventRouter",
        "data-query-currency": this.props.game.options.currency,
        "data-query-country": this.props.game.options.country,
        "data-query-user-token": this.props.game.options.userToken || null,
        "data-query-locale": this.props.game.options.locale
      }));
    }
  }]);

  return LottolandIframeContainer;
}(React__default.Component);
LottolandIframeContainer.propTypes = {
  countryCode: PropTypes__default.string.isRequired,
  currency: PropTypes__default.string.isRequired,
  game: PropTypes__default.object,
  gamePath: PropTypes__default.string,
  launchUrl: PropTypes__default.string.isRequired,
  locale: PropTypes__default.string.isRequired,
  operatorId: PropTypes__default.string.isRequired,
  sessionToken: PropTypes__default.string.isRequired,
  onEvent: PropTypes__default.func
};

/**
 * Fetch and render a game in a provider specific iFrame.
 * @param {Object} props
 * @param {string} props.betHistoryUrl Path for bet history page
 * @param {string} [props.clientType="browser"] Device type of the client, `browser` or `mobile-browser`
 * @param {string} props.gameId Id of game that will be fetched and rendered
 * @param {string} props.classicModeGameUrl Used to construct a url for Blitz Bonus Rounds (Required if you want to integrate Blitz-mode)
 * @param {string} props.language Player's current site language
 * @param {string} props.lobbyPath Used to construct lobbyUrl. For instance `casino`
 * @param {string} props.mountPoint Used to find games reducer. If games is under `games: games.reducer`, pass `games`
 * @param {string} props.netentLiveCasinoLobby Path for Netent's live casino lobby
 * @param {number} [props.realityCheckTimeRemaining] Number of milliseconds before reality check should be displayed
 * @param {ReactComponent} [props.placeholder] a component to show while loading
 * @param {function} props.onError Error handling that needs to be handled in host
 * @param {function} [props.onStart] Can be used for adding fetched game to quick-games. Needs to be dispatched in host.
 * @param {function} [props.onLoad] Handles providers redirecting to our app (e.g. on game quit or gambling history view), which causes app rendered inside the app recursively.
 * @return {ReactComponent}
 */

var GameLauncher =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GameLauncher, _React$Component);

  function GameLauncher() {
    _classCallCheck(this, GameLauncher);

    return _possibleConstructorReturn(this, _getPrototypeOf(GameLauncher).apply(this, arguments));
  }

  _createClass(GameLauncher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.clientType && this.props.onFetch();
      this.props.onStart && this.props.onStart(this.props.gameId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clientType !== this.props.clientType) {
        this.props.clientType && this.props.onFetch();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onOptionsClear(this.props.gameId);
    }
  }, {
    key: "render",
    value: function render() {
      if (R.isNil(R.path(['game', 'options'], this.props))) {
        return React__default.createElement(this.props.placeholder, null);
      }

      if (this.props.mode === 'blitz') {
        return React__default.createElement(BlitzIframeContainer, {
          game: this.props.game,
          classicModeGameUrl: this.props.classicModeGameUrl,
          onLoad: this.props.onLoad
        });
      } else if (this.props.game.provider === 'NetEnt') {
        return React__default.createElement(NetEntGameContainer$1, {
          authenticated: this.props.authenticated,
          game: this.props.game,
          liveCasinoLobby: this.props.netentLiveCasinoLobby,
          onError: this.props.onError,
          isRealityCheck: this.props.isRealityCheck
        });
      } else if (this.props.game.provider === 'Microgaming') {
        return React__default.createElement(MicrogamingGameContainer, {
          game: this.props.game,
          onError: this.props.onError,
          isRealityCheck: this.props.isRealityCheck
        });
      } else if (this.props.game.provider === 'Playngo') {
        return React__default.createElement(PlayNGoGameContainer$1, {
          game: this.props.game
        });
      } else if (this.props.game.launchMethod === 'lottoland-launcher') {
        return React__default.createElement(LottolandIframeContainer, {
          game: this.props.game,
          onEvent: this.props.onEvent
        });
      } else {
        return React__default.createElement(GameIframeContainer$1, {
          game: this.props.game,
          onLoad: this.props.onLoad
        });
      }
    }
  }]);

  return GameLauncher;
}(React__default.Component);
GameLauncher.defaultProps = {
  mode: 'classic',
  placeholder: function placeholder() {
    return null;
  }
};
GameLauncher.propTypes = {
  authenticated: PropTypes__default.bool,
  betHistoryUrl: PropTypes__default.string.isRequired,
  clientType: PropTypes__default.string,
  children: PropTypes__default.node,
  game: PropTypes__default.object,
  gameId: PropTypes__default.string.isRequired,
  isRealityCheck: PropTypes__default.string.isRequired,
  classicModeGameUrl: PropTypes__default.string,
  language: PropTypes__default.string.isRequired,
  lobbyPath: PropTypes__default.string.isRequired,
  mountPoint: PropTypes__default.string.isRequired,
  mode: PropTypes__default.string,
  netentLiveCasinoLobby: PropTypes__default.string,
  placeholder: PropTypes__default.func,
  realityCheckTimeRemaining: PropTypes__default.number,
  onError: PropTypes__default.func.isRequired,
  onEvent: PropTypes__default.func,
  onFetch: PropTypes__default.func.isRequired,
  onLoad: PropTypes__default.func,
  onOptionsClear: PropTypes__default.func.isRequired,
  onStart: PropTypes__default.func
};

function toEmptyHtmlRedirect(urlObj) {
  return R.merge(urlObj, {
    pathname: 'empty.html',
    query: {
      redirect: "/".concat(urlObj.pathname)
    }
  });
}

function mapStateToProps$5(state, props) {
  return {
    game: getGame(state[props.mountPoint], {
      id: props.gameId
    }),
    clientType: props.clientType !== 'unknown' ? props.clientType : undefined
  };
}

function mapDispatchToProps$2(dispatch, props) {
  return redux.bindActionCreators({
    onOptionsClear: clearGameOptions,
    onFetch: function onFetch() {
      var isGameId = parseInt(props.gameId, 10);
      var config = {
        success: function success(res) {
          return storeGameProps(props.gameId, res.value);
        },
        failure: function failure(res) {
          return props.onError(res.value.status ? "".concat(res.value.status, " ").concat(res.value.error) : res.value);
        },
        version: isGameId ? 2 : 1
        /*
        * Workaround for providers redirecting to our app (e.g. on game quit or
        * gambling history view), which causes app rendered inside the app
        * recursively.
        */

      };
      var needsRedirect = props.clientType === 'browser' && R.contains(R.path(['provider'], props.game), ['Pushgaming']);
      var referrer = R.concat(props.language, props.lobbyPath);
      var baseUrlObj = url.parse(window.location.href, false, true);
      var lobbyUrl = {
        protocol: baseUrlObj.protocol,
        host: baseUrlObj.host,
        pathname: referrer
      };
      var options = {
        id: props.gameId,
        type: props.clientType,
        elementId: 'game-container',
        language: props.language,
        lobbyUrl: url.format(needsRedirect ? toEmptyHtmlRedirect(lobbyUrl) : lobbyUrl),
        config: config,
        betHistoryUrl: props.betHistoryUrl,
        realityCheckTimeRemaining: props.realityCheckTimeRemaining
      };
      return isGameId ? api.fetchGame(options) : api.fetchLaunchParameters({
        id: props.gameId,
        provider: props.provider
      }, options.config);
    },
    storeGameProps: storeGameProps
  }, dispatch);
}

var connector$6 = reactRedux.connect(mapStateToProps$5, mapDispatchToProps$2);

var GameLauncher$1 = connector$6(GameLauncher);

exports.actions = actions;
exports.selectors = selectors;
exports.reducer = reducer;
exports.GameQuery = GameQuery$1;
exports.LiveCasinoQuery = LiveCasinoQuery$1;
exports.GameLauncher = GameLauncher$1;
//# sourceMappingURL=index.js.map
